import React from "react";
import CheckIcon from "assets/icons/HeroIcons/CheckIcon";
import XCloseIcon from "assets/icons/HeroIcons/XCloseIcon";
import { RenderCellContentProps } from "../../types";
import ellipsize from "ellipsize";
import useDateFormatter from "hooks/formatDateWithPattern";
import InputMark from "assets/icons/HeroIcons/InputMark";
import useCustomBranding from "hooks/useCustomBranding";

export const RenderCellContent: React.FC<RenderCellContentProps> = ({
  columnDef,
  cellValue,
}) => {
  const { formatDate } = useDateFormatter();
  const { getBrandPlaceholder } = useCustomBranding();
  if (
    typeof cellValue === "object" &&
    cellValue !== null &&
    columnDef.id === "createdBy"
  ) {
    return (
      <div className="flex justify-start w-[250px] items-center relative">
        <img
          src={
            cellValue?.personImage?.thumb
              ? cellValue?.personImage?.thumb
              : getBrandPlaceholder("listingProfile")
          }
          alt=""
          height="100"
          width="100"
          className="object-cover mx-2 Img_user_Data"
          style={{ flexShrink: 0 }}
        />
        <div
          style={{ flexWrap: "wrap" }}
          className=" flex flex-col w-full justify-start items-start relative gap-0.5"
        >
          <p className="text-sm w-[200px] text-left break-all text-textMid group-hover:text-primaryDark">
            {`${cellValue?.firstName} ${cellValue?.lastName}`}
          </p>
        </div>
      </div>
    );
  } else if (
    typeof cellValue === "object" &&
    cellValue !== null &&
    columnDef.id === "notificationName"
  ) {
    return (
      <div className="flex justify-start w-[250px] items-center relative">
        <div
          style={{ flexWrap: "wrap" }}
          className=" flex flex-col w-full justify-start items-start relative gap-0.5"
        >
          <p className="w-full text-sm text-left break-words text-textMid group-hover:text-primaryDark">
            {`${cellValue?.notificationName}`}
          </p>
        </div>
      </div>
    );
  } else if (
    (cellValue !== null && columnDef.id === "notificationCenter") ||
    columnDef.id === "toast" ||
    columnDef.id === "email" ||
    columnDef.id === "push"
  ) {
    return (
      <div className="relative flex items-start flex-grow py-1 px-3">
        {cellValue === true ? (
          <CheckIcon fill="#009F88" />
        ) : cellValue === null ? (
          <InputMark fill="#AFB1B3" />
        ) : (
          <XCloseIcon fill="#BF200B" />
        )}
      </div>
    );
  } else if (cellValue !== null && columnDef.id === "scheduledFor") {
    return (
      <div
        className={`relative flex items-start flex-grow py-1 px-3 ${
          columnDef.id === "address" ? "justify-start" : "justify-start"
        }`}
      >
        <p className={`text-sm text-left text-textMid group-hover:text-primaryDark whitespace-nowrap`}>
          {formatDate(cellValue?.toString())}
        </p>
      </div>
    );
  } else if (cellValue !== null && columnDef.id === "targetBy") {
    return (
      <div className="relative flex items-start flex-grow py-1 px-3 w-[150px]">
        <p className={`text-sm text-left text-textMid group-hover:text-primaryDark whitespace-nowrap`}>
          {cellValue?.map((item: any, index: any) => (
            <span key={index}>
              {item}
              <br />
            </span>
          ))}
        </p>
      </div>
    );
  } else if (cellValue !== null) {
    return (
      <div
        className={`relative flex items-start flex-grow py-1 px-3 ${
          columnDef.id === "address" ? "justify-start" : "justify-start"
        }`}
      >
        <p className={`text-sm text-left text-textMid group-hover:text-primaryDark whitespace-nowrap`}>
          {ellipsize(`${cellValue}`, 50)}
        </p>
      </div>
    );
  } else {
    return null;
  }
};
